/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type { FindStandardsQueryResponse } from "../types/FindStandards.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findStandardsQueryKey = () => [{ url: "/v1/standard" }] as const

export type FindStandardsQueryKey = ReturnType<typeof findStandardsQueryKey>

/**
 * @summary Find standards with
 * {@link /v1/standard}
 */
export async function findStandards(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindStandardsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/v1/standard`, ...requestConfig })
  return res
}

export function findStandardsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findStandardsQueryKey()
  return queryOptions<
    ResponseConfig<FindStandardsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindStandardsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findStandards({ ...config, signal: config.signal ?? signal })
    },
  })
}

/**
 * @summary Find standards with
 * {@link /v1/standard}
 */
export function useFindStandards<
  TData = ResponseConfig<FindStandardsQueryResponse>,
  TQueryData = ResponseConfig<FindStandardsQueryResponse>,
  TQueryKey extends QueryKey = FindStandardsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindStandardsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? findStandardsQueryKey()

  const query = useQuery(
    {
      ...findStandardsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
